import { EPType } from './config';

export function getEPSourceType(epType: EPType | string | undefined): string {
  let source_type = 'endpoint_data';
  if (epType === EPType.External) {
    source_type = 'endpoint_data_external';
  } else if (epType === EPType.Internal) {
    source_type = 'endpoint_data_internal';
  } else if (epType === EPType.EC2 || epType === 'AWS') {
    source_type = 'endpoint_data_ec2';
  }

  return source_type;
}
